import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { HomeEditionService, MoveAppNewsToArchivedOrNotParams } from 'src/Services/API';

import { MutationKeys, QueryKeys } from '../types';

export const useMoveAppNewsToArchivedOrNot = () => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.moveAppNewsToArchivedOrNot],
    async (params: MoveAppNewsToArchivedOrNotParams) => {
      return await HomeEditionService.homeEditionControllerMoveAppNewsToArchivedOrNot({
        body: params,
      });
    },
    {
      onSuccess: () => {
        toast.success("la nouveauté a changé de statut d'archivage");
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchAllAppNews] });
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchAllAppNews] });
        switch (error.response?.status) {
          case 403:
            toast.error("droits insuffisants pour modifier le statut d'archivage de la nouveauté");
            break;
          default:
            toast.error("erreur lors de la modification du statut d'archivage de la nouveauté");
            break;
        }
      },
    }
  );
};
